import {
  animate,
  sequence,
  style,
  transition,
  trigger
} from "@angular/animations";

export const DropDownAnimation = trigger("dropDown", [
  transition(":enter", [
    style({
      height: 0,
      overflow: "hidden",
      animationTimingFunction: "linear"
    }),
    sequence([
      animate("200ms", style({ height: "*" }))
    ])
  ]),

  transition(":leave", [
    style({
      height: "*",
      overflow: "hidden",
      animationTimingFunction: "linear"
    }),
    sequence([
      animate("200ms", style({ height: 0 }))
    ])
  ])
]);
